<template>
  <main class="pt-16 bg-gradient-to-b from-gray-100 via-gray-200 to-gray-100">
    <div class="w-full py-6 sm:py-8 pb-8 sm:pb-10 lg:pb-12">
      <div class="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        <h1 class="text-lg sm:text-xl md:text-2xl lg:text-3xl font-medium text-gray-900 mb-6 sm:mb-8 lg:mb-12 text-center px-2">
          Où commander un smartphone REDMI Note 15 Series ?
        </h1>

        <!-- Loading state -->
        <div v-if="loading" class="text-center py-12">
          <div class="inline-block animate-spin rounded-full h-8 w-8 border-4 border-orange-500 border-t-transparent"></div>
          <p class="mt-4 text-gray-600">Chargement des enseignes...</p>
        </div>

        <template v-else>
          <!-- Section unique : Toutes les enseignes -->
          <section>
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-3 md:gap-4">
              <a
                v-for="enseigne in toutesLesEnseignes"
                :key="enseigne.name"
                :href="getEnseigneUrl(enseigne)"
                target="_blank"
                rel="noopener noreferrer"
                class="group relative bg-white rounded-lg border border-gray-200 p-3 sm:p-4 md:p-6 flex items-center justify-center h-20 sm:h-24 md:h-28 transition-all overflow-hidden hover:shadow-lg hover:border-orange-300 cursor-pointer"
              >
                <img v-if="getEnseigneLogo(enseigne)" :src="getEnseigneLogo(enseigne)" :alt="enseigne.name" :class="[getEnseigneLogoClass(), 'w-auto object-contain']" />
                <span v-else class="text-sm sm:text-base md:text-lg font-medium text-center text-gray-700">{{ getDisplayName(enseigne) }}</span>
                <div class="absolute bottom-0 left-0 right-0 bg-gray-900 text-white text-xs sm:text-sm font-medium py-1 sm:py-2 text-center transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  {{ getDisplayName(enseigne) }}
                </div>
              </a>
            </div>
          </section>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
const API_URL = 'https://api-houston.promo.dev/api/v2/data-list/json/694e81ea31ab0a1506628821';

export default {
  name: "PartenairesView",
  data() {
    return {
      enseignes: [],
      loading: true,
    };
  },
  computed: {
    toutesLesEnseignes() {
      // Liste des enseignes à exclure
      const enseignesExclues = ['La Poste', 'Orange Store', 'Xiaomi Store'];
      
      // Filtrer les enseignes exclues et supprimer les doublons basés sur le nom nettoyé
      const enseignesUniques = new Map();
      
      this.enseignes.forEach(enseigne => {
        const nomNettoye = this.getDisplayName(enseigne);

        // Vérifier si l'enseigne n'est pas dans la liste d'exclusion et a une URL
        if (!enseignesExclues.includes(nomNettoye) && !enseignesUniques.has(nomNettoye) && this.hasUrl(enseigne)) {
          enseignesUniques.set(nomNettoye, enseigne);
        }
      });
      
      // Convertir la Map en tableau et trier par nom
      return Array.from(enseignesUniques.values()).sort((a, b) => {
        const nameA = this.getDisplayName(a).toLowerCase();
        const nameB = this.getDisplayName(b).toLowerCase();
        return nameA.localeCompare(nameB);
      });
    },
  },
  methods: {
    getDisplayName(enseigne) {
      return enseigne.name.replace(' (hors Marketplace)', '');
    },
    getEnseigneLogo(enseigne) {
      return enseigne.metadata?.logo || null;
    },
    getEnseigneUrl(enseigne) {
      return enseigne.metadata?.url || '#';
    },
    hasUrl(enseigne) {
      return !!enseigne.metadata?.url;
    },
    getEnseigneLogoClass() {
      return 'max-h-10 sm:max-h-12 md:max-h-14';
    },
    async fetchEnseignes() {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error('Erreur réseau');
        this.enseignes = await response.json();
      } catch (error) {
        console.error('Erreur lors du chargement des enseignes:', error);
        this.enseignes = [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchEnseignes();
  },
};
</script>

<style scoped>
a:hover img,
a:hover span {
  transform: scale(1.05);
}

a img,
a span {
  transition: transform 0.3s ease;
}
</style>
